// Module
var code = "<div class=dashWrapper><secondary-nav class=inbox-version active=premium></secondary-nav><membership-account class=membershipAccount ready=$ctrl.componentIsReady></membership-account></div>";
// Exports
module.exports = code;